import React, { useState, useEffect } from 'react';
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { useStateContext } from '../../context/ContextProvider';
import { EditTextQill } from './utils';
import { DLabel, Select, DSpinButton, TextArea } from '../utils/Form';
import { getAllCategorys } from '../../redux/actions/category';
import { toast } from 'react-toastify';
import { Loader } from '../utils';
import { useParams } from "react-router-dom";
import { BaseUrl, media } from '../../server';
import { getMeal } from '../../redux/actions/meals';
import ImageUploadWithResize from '../../utils/ImageUploadWithResize';


function EditMeal() {
  const { t } = useTranslation();
  const { currentColor } = useStateContext();

  const dispatch = useDispatch();
  const [isSpinner, setIsSpinner] = useState(false);
 
  const { id } = useParams();

  useEffect(() => {
    dispatch(getMeal(id));
    dispatch(getAllCategorys());
  }, [dispatch, id]);
  
  const { mealData, isLoadingmeal } = useSelector((state) => state.Meals);
  const { isLoading, AllCategorys } = useSelector((state) => state.Categorys);
  
  const [titleAr, setTitleAr] = useState(mealData?.titleAr);
  const [titleEn, setTitleEn] = useState(mealData?.titleEn);
  const [textEn, setTextEn] = useState(mealData?.textEn);
  const [categoryId, setCategoryId] = useState(mealData?.categoryId?._id);
  const [textAr, setTextAr] = useState(mealData?.textAr);
  const [date, setDate] = useState(mealData?.date);
  const [image, setImage] = useState(mealData?.Image);
  const [imageShow, setImageShow] = useState(null);
  const [price, setPrice] = useState(mealData?.price);

  useEffect(() => {
    if (mealData) {
      setTitleAr(mealData.titleAr);
      setTitleEn(mealData.titleEn);
      setTextEn(mealData.textEn);
      setCategoryId(mealData.categoryId?._id);
      setTextAr(mealData.textAr);
      setDate(mealData.date);
      setImage(mealData.Image);
      setImageShow({ url: `${media}${mealData.Image}` });
      setPrice(mealData.price);
    }
  }, [mealData]);

  const Updatemeal = async (newForm) => {
    try {
      const config = { 
        headers: { "Content-Type": "multipart/form-data" },
        withCredentials: true 
      };
      const { data } = await axios.put(`${BaseUrl}/blogs/${id}`, newForm, config);

      if (data.success) {
        toast.success(
          <span className="font-kufi text-tcolor-4 dark:text-tcolor-1 text-sm">
            {t("Meal updated successfully!")}
          </span>
        );
        setIsSpinner(false);
      }
    } catch (error) {
      toast.error(error.response?.data?.message);
      setIsSpinner(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSpinner(true);
    const newForm = new FormData();

    // إضافة الصورة فقط إذا كانت موجودة وتم تغييرها
    if (image instanceof File) {
      newForm.append("file", image);
    }

    newForm.append("categoryId", categoryId);
    newForm.append("date", date);
    newForm.append("titleAr", titleAr);
    newForm.append("titleEn", titleEn);
    newForm.append("textAr", textAr);
    newForm.append("textEn", textEn);
    if (price ){
      newForm.append("price", price);
    }

    Updatemeal(newForm);
  };

  return (
    <>
      {isLoading || isLoadingmeal ? (
        <Loader />
      ) : (
        <div className="w-[90%] bg-back-primery lg:w-[50%] m-2 md:m-10 mt-24 p-2 md:p-10 rounded-3xl">
          <h3 className="text-xl font-semibold text-color-1 font-kufi color text-center">
            {t("Edit Meal")}
          </h3>
          <form onSubmit={handleSubmit}>
            <br />
            <div>
              <DLabel
                labelText="Title (Ar)"
                value={titleAr}
                onChange={(e) => setTitleAr(e.target.value)}
                required={true}
                type="text"
                name="titleAr"
              />
              <DLabel
                labelText="Title (En)"
                value={titleEn}
                onChange={(e) => setTitleEn(e.target.value)}
                required={true}
                type="text"
                name="titleEn"
              />
              <DLabel
                labelText="Price"
                value={price}
                onChange={(e) => setPrice(e.target.value)}
                required={false}
                type="number"
                name="price"
              />
              <Select 
                Data={AllCategorys} 
                labelText={t("Select Category")} 
                value={categoryId} 
                setValue={setCategoryId} 
                required={true} 
              />
              <TextArea 
                labelText={t("Description (Ar)")} 
                value={textAr} 
                onChange={(e) => setTextAr(e.target.value)} 
                required={true} 
              />
              <TextArea 
                labelText={t("Description (En)")} 
                value={textEn} 
                onChange={(e) => setTextEn(e.target.value)} 
                required={true} 
              />

              {/* استخدام كمبوننت ضغط الصور الجديد */}
              <ImageUploadWithResize
                imageShow={imageShow}
                setImageShow={setImageShow}
                setImage={setImage}
                currentColor={currentColor}
                label="Upload Image"
                required={true}
                maxWidth={1024}
                maxHeight={1024}
                quality={80}
              />
              
              <br />
            </div>
            <DSpinButton isLoading={isSpinner}>{t("Edit")}</DSpinButton>
          </form>
        </div>
      )}
    </>
  );
}

export default EditMeal;